export function fillInvoiceTemplate(templateHtml, invoice) {
  // Example replacements; adjust keys to match your template and invoice object
  let filled = templateHtml
    .replace('{{InvoiceNumber}}', invoice.InvoiceNumber || '')
    .replace('{{CustomerName}}', invoice.CustomerName || '')
    .replace('{{InvoiceDate}}', invoice.InvoiceDate || '')
    .replace('{{TotalIncl}}', invoice.InvoicePrice || '')
    .replace('{{TotalExcl}}', invoice.TotalExcl || '')
    .replace('{{TotalVAT}}', invoice.TotalVAT || '')
    // ...add more replacements as needed
  ;

  // If you have line items or outstanding rows, generate and replace those too
  // Example for line items:
  if (invoice.LineItems) {
    const productRows = invoice.LineItems.map(item => `
      <tr>
        <td>${item.Name}</td>
        <td>${item.Quantity}</td>
        <td>€${item.Price}</td>
        <td>${item.VAT}%</td>
        <td>€${item.TotalExcl}</td>
      </tr>
    `).join('');
    filled = filled.replace('{{ProductRows}}', productRows);
  }

  // Add similar logic for outstanding invoices if needed

  return filled;
}